import { useCallback, useState } from "react";
import { useDialog } from "@/lib/dialogs/DialogProvider";

/**
 * Ersatz für withFormBusy() aus src/components/AuthHandlers.js: sperrt den
 * Submit-Button während der Anfrage und zeigt Fehler als blockierenden Dialog,
 * exakt wie zuvor (Titel "Anfrage fehlgeschlagen", Nachricht aus error.message).
 */
export function useAsyncAction() {
  const [pending, setPending] = useState(false);
  const { alert } = useDialog();

  const run = useCallback(
    async (action: () => Promise<void>, options?: { errorTitle?: string }) => {
      setPending(true);
      try {
        await action();
      } catch (error) {
        const message = error instanceof Error ? error.message : "Die Anfrage ist fehlgeschlagen.";
        await alert(message, { title: options?.errorTitle || "Anfrage fehlgeschlagen" });
      } finally {
        setPending(false);
      }
    },
    [alert]
  );

  return { run, pending };
}
